import { render, staticRenderFns } from "./OfflineRecords.vue?vue&type=template&id=2ce774ff&scoped=true"
import script from "./OfflineRecords.vue?vue&type=script&lang=js"
export * from "./OfflineRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce774ff",
  null
  
)

export default component.exports